import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import { useState } from 'react'
import CreatePassportSidePage from '@/pages/MDM/components/Passports/CreatePassportSidePage'
import usePassportSchemas from '@/pages/MDM/hooks/usePassportSchemas.ts'
import MDMListValue from '@/pages/MDM/components/MDMListValue'
import PassportIcon from '@/assets/icons/mdm/passport.svg?react'
import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl.ts'
import PassportSchemaSidePage from '@/pages/MDM/components/Passports/PassportSchemaSidePage'
import { IPassportSchema } from '@/pages/MDM/mdm.types.ts'
import confirmService from '@/services/ConfirmService/confirm.service.ts'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'
import MenuOptionEdit from '@/shared/Dropdowns/DropdownListItem/DropdownListItemEdit'
import MenuOptionDelete from '@/shared/Dropdowns/DropdownListItem/DropdownListItemDelete'
import ProtectedContent from '@/services/rights/ProtectedContent'
import useSelfAccessRightsSet from '@/services/rights/useSelfAccessRIghtsSet.ts'

const PassportsTabContent = () => {
  const selfAccessRights = useSelfAccessRightsSet()

  const schemas = usePassportSchemas()
  const sidePageCtrl = useSidePageWithTableCtrl(schemas)

  const [createSidePageOpen, setCreateSidePageOpen] = useState(false)

  const handleDeletePassport = (passport: IPassportSchema) => {
    confirmService.requestConfirm({
      description: `Подтвердите удаление паспорта ${passport.name}`,
      buttonType: 'primary',
      onConfirm: () =>
        mdmApi
          .deletePassportSchema(passport.id)
          .then((r) => r.status === 'success' && mdmEvents.passportSchemaDeleted(r.body.id)),
    })
  }

  const renderMenu = (passport: IPassportSchema) => {
    if (!selfAccessRights.has('mdm:delete_schema') && !selfAccessRights.has('mdm:update_schema')) {
      return null
    }

    return (
      <div className="flex-lines">
        <MenuOptionEdit text="Редактировать" onClick={() => sidePageCtrl.handleItemPageOpen(passport)} />
        <MenuOptionDelete text="Удалить" onClick={() => handleDeletePassport(passport)} />
      </div>
    )
  }

  return (
    <div className="flex-lines gap24">
      <ProtectedContent
        requiredRight="mdm:create_schema"
        fallBack={
          <span className="text-nm text-description">
            Для создания новой схемы паспорта обратитесь к администратору системы
          </span>
        }
      >
        <CreateEntityButton onClick={() => setCreateSidePageOpen(true)} text="Создать схему паспорта" />
      </ProtectedContent>
      <div className="flex-lines">
        {schemas.map((s) => (
          <MDMListValue
            key={s.id}
            name={s.name}
            icon={<PassportIcon />}
            onClick={() => sidePageCtrl.handleItemPageOpen(s)}
            menuOptions={renderMenu(s)}
          />
        ))}
      </div>

      <PassportSchemaSidePage
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
        passport={sidePageCtrl.selectedItem}
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
      />
      <CreatePassportSidePage open={createSidePageOpen} onClose={() => setCreateSidePageOpen(false)} />
    </div>
  )
}

export default PassportsTabContent
